"use client";

import { usePathname, useRouter } from "next/navigation";
import { useEffect } from "react";

import { Route } from "@/enums/route";
import { isWriteRestrictedPath } from "@/utils/accountStateAccess";

/**
 * Mounted by AccountStateGate ONLY for SUSPENDED (view-only) accounts, after
 * the user has acknowledged the suspension warning. Redirects any
 * write-restricted route (pay flows, exchange, recipient creation — see
 * isWriteRestrictedPath) back to the dashboard, and renders nothing while on
 * one so the write page's components never mount.
 */
export function SuspendedRouteGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const router = useRouter();
  const isRestricted = isWriteRestrictedPath(pathname);

  useEffect(() => {
    if (isRestricted) {
      router.replace(Route.Dashboard);
    }
  }, [isRestricted, router]);

  if (isRestricted) return null;

  return <>{children}</>;
}
